export const CURRENT_DASHBOARD_INIT_DASHBOARD = "CURRENT_DASHBOARD_INIT_DASHBOARD";
export const CURRENT_DASHBOARD_WIDGET_UPDATED = "CURRENT_DASHBOARD_WIDGET_UPDATED";
export const CURRENT_DASHBOARD_WIDGET_ADDED = "CURRENT_DASHBOARD_WIDGET_ADDED";
export const CURRENT_DASHBOARD_WIDGET_REMOVED = "CURRENT_DASHBOARD_WIDGET_REMOVED";
export const CURRENT_DASHBOARD_CHECK_WIDGET_LOADED = "CURRENT_DASHBOARD_CHECK_WIDGET_LOADED";
export const CURRENT_DASHBOARD_CHANGE_TITLE = "CURRENT_DASHBOARD_CHANGE_TITLE";
export const CURRENT_DASHBOARD_TOGGLE_WIDGET_ENLARGE = "CURRENT_DASHBOARD_TOGGLE_WIDGET_ENLARGE";
export const CURRENT_DASHBOARD_WIDGET_ENLARGE_STATE_CHANGED = "CURRENT_DASHBOARD_WIDGET_ENLARGE_STATE_CHANGED";
export const CURRENT_DASHBOARD_IS_LOADING = "CURRENT_DASHBOARD_IS_LOADING";
export const CURRENT_DASHBOARD_RESET = "CURRENT_DASHBOARD_RESET";
